import React from "react"

export default function SectionHeading({ eyebrow, title, lead, id, align = "left" }) {
  const alignment = align === "center" ? "mx-auto text-center" : ""

  return (
    <div className={`max-w-3xl ${alignment}`}>
      {eyebrow && (
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.14em] text-brand-primary">
          {eyebrow}
        </p>
      )}
      <h2
        id={id}
        className="text-3xl font-bold leading-tight tracking-tight text-brand-heading sm:text-4xl"
      >
        {title}
      </h2>
      {lead && <p className="mt-4 text-lg leading-relaxed text-brand-textSoft">{lead}</p>}
    </div>
  )
}
